import type { BatchTypeValueSet } from '~/common/model/api/batch-type';

import type { TransformBatchTypes } from './_batch-type.type';

/**
 * Prepare BatchTypes.
 *
 * @param {TransformBatchTypes} batchTypes Transform BatchTypes.
 *
 * @returns {BatchTypeValueSet[]} BatchTypes.
 */
export function prepareBatchTypes(batchTypes: TransformBatchTypes): BatchTypeValueSet[] {
  return Object.entries(batchTypes).map(([id, batchType]) => ({
    ...batchType,
    id,
  }));
}
